import styled from 'styled-components';
import { theme } from '../../../theme';

const { colors, up, breakpoints } = theme;

export const DivWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;

  &.inventory-modal {
    padding: 0.5rem 1rem 0.8rem;
  }

  &.colorgate-configuration-modal {
    padding-bottom: 2.308rem;
    padding-top: 2.308rem;
    background-color: ${colors.surfaceBase};
  }

  ${theme.up(theme.breakpoints.sm)} {
    flex-direction: row;
  }
`;

export const DivImage = styled.div`
  margin-right: 1.538rem;
  margin-bottom: 1.538rem;
  width: 5.385rem;
  min-width: 5.385rem;
  height: 5.385rem;
  border-radius: 5px;
  border: 1px solid ${colors.line};
  background-color: ${colors.white};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  ${theme.up(theme.breakpoints.sm)} {
    margin-bottom: 0;
  }
`;

export const DivTextWrapper = styled.div`
  height: 5.385rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const DivTitle = styled.div`
  margin-bottom: 0.615rem;
  font-weight: 600;
  font-size: 1.231rem;
  color: ${colors.textPrimary};
`;

export const DivDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 0.923rem;
  line-height: 1.7;
  color: ${colors.textPrimary};
`;

export const DivCircle = styled.div`
  display: inline-block;
  margin-right: 0.308rem;
  width: 1.078rem;
  height: 1.078rem;
  border-radius: 100%;
`;

export const SpanFieldName = styled.span`
  font-weight: 600;
  margin-right: 0.308rem;

  ${up(breakpoints.sm)} {
    margin-right: 0.615rem;
  }
`;

export const SpanFieldValue = styled.span`
  margin-right: 0.615rem;

  ${up(breakpoints.sm)} {
    margin-right: 1.846rem;
  }

  ${up(breakpoints.lg)} {
    margin-right: 2.307rem;
  }
`;

export const SpanRemark = styled.span`
  font-weight: 500;
  color: ${colors.secondary};
`;
